import { z } from 'zod'

import {
  apiClient,
  Auth,
  InfiniteScroll,
  ZPaginationSearchParams,
} from '@/shared/api'

import { TSearchRoom } from '../model/schema'
import { ZMapBounds, ZMapZoomLevel, ZSearchFilter } from '../model/schema'

export const ZRoomSearchParams = ZSearchFilter.merge(ZMapBounds.partial())
  .merge(ZPaginationSearchParams)
  .extend({
    roomMarkerLat: z.number().optional(),
    roomMarkerLng: z.number().optional(),
    zoomLevel: ZMapZoomLevel.optional(),
  })

export type TRoomSearchParams = z.infer<typeof ZRoomSearchParams>

export type TRoomResponse = InfiniteScroll<TSearchRoom>

export const getRooms = async (params: TRoomSearchParams) => {
  const { data } = await apiClient.get<TRoomResponse>({
    endpoint: `/map/rooms`,
    queryParams: params,
    option: {
      cache: 'no-store',
    },
    auth: Auth.OPTIONAL,
  })

  return data
}
